import { render, staticRenderFns } from "./YoutubeLatest.vue?vue&type=template&id=6893becc&"
import script from "./YoutubeLatest.vue?vue&type=script&lang=ts&"
export * from "./YoutubeLatest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports